export default class StringPacking
{
    public static Compress(a : string, b : string, separator : string = "\xff") : string
    {
        if (a == null)
            a = "";
        if (b == null)
            b = "";
        return a + separator + b;
    }

    public static Split(compressed : string, separator : string = "\xff") : string[]
    {
        return compressed.split(separator);
    }
}